export default __webpack_public_path__ + "static/media/exp_D.401e436b.png";